import { createSlice } from "@reduxjs/toolkit";
import { toGetFaq } from "../actions/faq.actions";

const initialState = {
  faq: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const faqSlice = createSlice({
  name: "faq",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetFaq.pending, (state) => {
      state.faq = { list: [], status: "idle" };
    });
    builder.addCase(toGetFaq.fulfilled, (state, action) => {
      state.faq = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetFaq.rejected, (state, action) => {
      state.faq = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default faqSlice.reducer;
